import { Box, Link, Typography } from "@mui/material"
import { ReactElement } from "react"

import { CONNECT_DIRECT_SUPPORT_EMAIL } from "../errors/errorMessages"
import { LEARN_MORE } from "../router/routes"

interface UnableToLoginHelpProps {
    themed?: boolean
}

const UnableToLoginHelp = ({
    themed,
}: UnableToLoginHelpProps): ReactElement => (
    <Box
        display="flex"
        flexDirection="column"
        sx={themed ? {} : { color: "black" }}
    >
        <Typography variant="subtitle1" fontWeight={300} fontSize="small">
            Unable to log in? Check if your issue is shown{" "}
            <Link href={`${LEARN_MORE}#mfa`} target="_blank">
                here
            </Link>{" "}
            or email{" "}
            <Link
                href={`mailto:${CONNECT_DIRECT_SUPPORT_EMAIL}`}
                target="_blank"
            >
                {CONNECT_DIRECT_SUPPORT_EMAIL}
            </Link>{" "}
            for support.
        </Typography>
    </Box>
)

export default UnableToLoginHelp
